import React, { Component } from 'react';
import axios from 'axios';
import ApiURL from "../../api/ApiURL";
import cogoToast from "cogo-toast";
import LocalStorageHelper from "../../LocalStorageHelper/LocalStorageHelper";
import PageTitle from "../home/PageTitle";
import AgGridComponent from '../common/AgGridComponent';
import PaginationComponent, { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../common/PaginationComponent';
import { createMasterActionColumn, createMasterActiveColumn } from '../../utils/masterGridHelpers';
import {
  buildMasterGridParams,
  SPECIALIST_SORT_WHITELIST,
  SPECIALIST_FILTER_WHITELIST,
} from '../../utils/agGridServerHelpers';


export default class SpecialList extends Component {
  //constructor lifecycle event
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showDeleteWarnModal: false,
      SPLData: [],
      isTableLoading: true,
      currentPage: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      totalRecords: 0,
      columnDefs: [],
      sortModel: [],
      filterModel: {},
      splId: 0,
      specialistName: '',
      mobile: '',
      email: '',
      userId: 0,
      userRole: '',
      isActive: false
    };
  }
  //componentDidMount lifecycle event
  componentDidMount() {
    window.scroll(0, 0);
    var userData = JSON.parse(LocalStorageHelper.getUser());
    if (userData !== null && userData.UserId > 0) {
      this.setState({
        userId: userData.UserId,
        userRole: userData.RoleName,
        displayName: userData.DisplayName
      })
    }
    this.getAllSPLData();
    this.getAllDataColumns();
  }
  //Data Reload
  handleReload = () => this.setState({ currentPage: 1 }, this.getAllSPLData);
  handleSortChange = (sortModel) => {
    this.setState({ sortModel, currentPage: 1 }, this.getAllSPLData);
  };
  handleFilterChange = (filterModel) => {
    this.setState({ filterModel, currentPage: 1 }, this.getAllSPLData);
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page }, this.getAllSPLData);
  };
  handlePageSizeChange = (size) => {
    this.setState({ pageSize: size, currentPage: 1 }, this.getAllSPLData);
  };
  //Reset all input fields into the modal
  resetInputFields = () => {
    this.setState({
      showModal: false,
      showDeleteWarnModal: false,
      splId: 0,
      specialistName: "",
      mobile: "",
      email: "",
      isActive: false
    });
  }
  //Open modal
  openModal = () => this.setState({ showModal: true });
  //Close modal
  closeModal = () => this.setState({ showModal: false });
  //Open Delete warning modal
  openWarnModal = () => this.setState({ showDeleteWarnModal: true });
  //Close Delete warning modal
  closeWarnModal = () => this.setState({ showDeleteWarnModal: false });
  //OnChangeHandler
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
  //Get all data
  getAllSPLData = () => {
    const { currentPage, pageSize, sortModel, filterModel } = this.state;
    const param = buildMasterGridParams(
      currentPage,
      pageSize,
      sortModel,
      filterModel,
      SPECIALIST_SORT_WHITELIST,
      SPECIALIST_FILTER_WHITELIST
    );
    this.setState({ isTableLoading: true });
    axios
      .post(ApiURL.GetAllSPL, param)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult;
          this.setState({
            SPLData: dataResult.Specialists,
            totalRecords: dataResult?.TotalRecords ?? 0,
          });
        } else if (respData.StatusCode === 404) {
          this.setState({ SPLData: [], totalRecords: 0 });
        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      })
      .finally(() => {
        this.setState({ isTableLoading: false });
      });
  }
  //Get all columns
  getAllDataColumns = () => {
    this.setState({
      columnDefs: [
        createMasterActionColumn(this.getDataItemById, "SpecialistId"),
        { headerName: "Specialist", field: "SpecialistName", flex: 1.5, minWidth: 140, cellClass: "text-left" },
        { headerName: "Mobile", field: "Mobile", width: 130, cellClass: "text-center" },
        { headerName: "Email", field: "Email", flex: 1.5, minWidth: 140, cellClass: "text-left" },
        createMasterActiveColumn(),
      ],
    })
  }
  //Get data by Id
  getDataItemById = (keyData) => {
    var self = this;
    axios
      .get(ApiURL.GetSPLById(keyData))
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult;
          self.setState({
            splId: dataResult.SpecialistId,
            specialistName: dataResult.SpecialistName,
            mobile: dataResult.Mobile,
            email: dataResult.Email,
            isActive: dataResult.IsActive,
            showModal: true,
          });
        }
        else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      });
  }
  //Handle Add new Record
  handleAddNew = () => {
    this.resetInputFields();
    this.openModal();
  }
  //Delete data by Id
  handleDelete = () => {
    let param = {
      SpecialistId: this.state.splId,
      IsActive: false
    };

    axios.post(ApiURL.DeleteSPL, param)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          cogoToast.success("Specialist Deleted Successfully!", { position: "bottom-center" });
          this.resetInputFields();
          this.closeWarnModal();
          this.getAllSPLData();
        }
        else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      });
  }
  //save data
  handleSubmit = (e) => {
    e.preventDefault();
    //set blank validation
    if (!this.state.specialistName || !this.state.mobile){
      //|| !this.state.email) {
      cogoToast.error("Please fill all required fields.", { position: "bottom-center" });
      return;
    }

    let param = {
      SpecialistId: this.state.splId,
      specialistName: this.state.specialistName,
      mobile: this.state.mobile,
      email: this.state.email,
      isActive: this.state.isActive
    };
    axios
      .post(ApiURL.SaveSPL, param)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          cogoToast.success("Specialist Saved Successfully!", { position: "bottom-center" });
          this.resetInputFields();
          this.getAllSPLData();
        }
        else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      });
  }
  //render lifecycle event.
  render() {
    var self = this;
    const { showModal, splId, showDeleteWarnModal, SPLData, columnDefs, currentPage, pageSize, totalRecords } = self.state;
    return (
      <>
        <div className="master-page">
        <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
          <div className="card bg-primary-subtle flex-row py-1 mb-0 mx-2">
            <div className="col-md-9 justify-content-start">
              <PageTitle Title="Manage Specialist" />
            </div>
            <div className="col-md-3 text-right pt-1">
              <button className="btn btn-outline-dark btn-sm px-3 mx-3" title="Refresh" onClick={this.handleReload}>
                <i className="fa-solid fa-arrows-rotate"></i> Refresh
              </button>
              <button className="btn btn-outline-primary btn-sm px-3 cursor-pointer" title="Add" onClick={this.handleAddNew}>
                <i className="fa-solid fa-plus"></i> Add
              </button>
            </div>
          </div>
        </div>
        <div className="master-page__body">
          <PaginationComponent
            currentPage={currentPage}
            totalPages={Math.ceil(totalRecords / pageSize) || 1}
            pageSize={pageSize}
            totalRecords={totalRecords}
            pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
            onPageChange={this.handlePageChange}
            onPageSizeChange={this.handlePageSizeChange}
          />
          <div className="master-page__grid">
            <AgGridComponent
              columnDefs={columnDefs}
              rowData={SPLData}
              isLoading={this.state.isTableLoading}
              onSortChange={this.handleSortChange}
              onFilterChange={this.handleFilterChange}
              fillHeight
            />
          </div>
        </div>
        </div>

        {/* <!----------------- modal section----------------> */}
        <div className={showModal === true ? "modal show-modal  modalWrapper" : "modal"} tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title ">{splId <= 0 ? `Add Specialist` : `Update Specialist`}</h1>
                <i className="fa-regular fa-circle-xmark text-danger" data-bs-dismiss="modal" onClick={this.closeModal}></i>
              </div>
              <div className="modal-body">
                <div className="row ">
                  <div className="col">
                    <label htmlFor="splname" className="form-label text-sm" style={{ fontSize: "15px" }}>Specialist Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Specialist Name"
                      name="specialistName"
                      value={this.state.specialistName}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="mobile" className="form-label text-sm" style={{ fontSize: "15px" }}>Mobile No. * </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Mobile No."
                      name="mobile"
                      value={this.state.mobile}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="email" className="form-label text-sm" style={{ fontSize: "15px" }}>Email Id * </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      name="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer my-3">
                <button
                  type="submit"
                  className="btn btn-success button-box-shadow"
                  onClick={this.handleSubmit}
                >
                  <i className="fa-regular fa-floppy-disk"></i> Save
                </button>
                {
                  this.state.userRole === 'admin' &&
                  <button
                    type="button"
                    className={`btn btn-danger button-box-shadow curser-pointer ${splId > 0 ? '' : 'disabled'}`}
                    onClick={() => { splId > 0 && this.openWarnModal() }}
                  >
                    <i className="fa-solid fa-trash-can"></i> Delete
                  </button>
                }
                <button
                  type="button"
                  className="btn btn-secondary button-box-shadow"
                  data-bs-dismiss="modal"
                  onClick={this.closeModal}
                >
                  <i className="fa-solid fa-circle-xmark"></i> Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* <!------DELETE Warning Modal--------> */}
        <div className={showDeleteWarnModal === true ? "modal show-modal" : "modal"}>
          <div className="modal-dialog modal-dialog-centered modal-md ">
            <div className="modal-content button-box-shadow">
              <div className="modal-body">
                <div className="alert alert-warning d-flex align-items-center" role="alert" >
                  <i className="fa-solid fa-triangle-exclamation"></i>&nbsp;
                  <div><strong>Are you sure</strong>, you want to <strong>Delete </strong> it?</div>
                </div>
              </div>
              <div className="modal-footer ">
                <button
                  type="button"
                  className="btn btn-danger button-box-shadow btn-sm"
                  onClick={this.handleDelete}
                >
                  <i className="fa-solid fa-trash-can"></i> Delete
                </button>

                <button
                  type="button"
                  className="btn btn-secondary button-box-shadow btn-sm"
                  data-bs-dismiss="modal"
                  onClick={this.closeWarnModal}
                >
                  <i className="fa-solid fa-circle-xmark"></i> Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
